import { createFileRoute } from '@tanstack/react-router';
import { RulesPage } from '@/features/settings/rules/rules-page';

export const Route = createFileRoute('/_app/settings/rules')({
  component: RulesPage,
});
